import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import {
  fetchProductTypeInterventions,
  selectProductTypeInterventions,
  selectProductTypeInterventionsLoading,
} from 'features/products/store/product.slice';
import { QueryParams } from 'shared/types';
import { DocumentStatus } from 'features/documents/models';

export const useProductTypeInterventionsQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query, limit: 'unlimited' };

    return [queryParams];
  }, []);
};

export const useProductTypeInterventions = (query: QueryParams) => {
  return useFetchByParams<DocumentStatus[]>({
    action: fetchProductTypeInterventions,
    dataSelector: selectProductTypeInterventions,
    loadingSelector: selectProductTypeInterventionsLoading,
    params: query,
  });
};
